import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import PlaceholderReportScreen from './PlaceholderReportScreen';

const ForwardOccupancyReportScreen: React.FC = () => (
  <PlaceholderReportScreen
    title="Forward Occupancy"
    description="Future occupancy, vacancy and category-wise availability — promotion-targeting input."
    icon={<IconSystem.calendar size={18} />}
    phaseLabel="Coming in Phase 5"
    comingSoonHint="Day × room category matrix of available rooms and occupancy %."
  />
);
export default ForwardOccupancyReportScreen;
